import * as z from "zod";

/**
 * The signed-in user's picked home page wins, in display order. Empty when they
 * haven't picked, so the page derives its own default.
 */
export const getHomeWins = {
  name: "getHomeWins" as const,
  input: z.null(),
  output: z.object({
    refs: z.array(z.string()),
    /**
     * False when the user is viewing a store they don't belong to, such as a
     * Redo employee, so a pick there lasts only for the session.
     */
    canSave: z.boolean(),
  }),
};
